import type { FC } from 'react';
import { lazy } from 'react';
import type { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useCmNetworkPoint } from 'src/apis/capacity-management/use-cm-network-point';
import { useTechnicalCapacity } from 'src/apis/capacity-management/use-technical-capacity';
import type { NetworkPointRequest } from 'src/apis/monolith/use-network-point';
import type { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

type Props = {
  networkPoint: Successful<NetworkPointRequest>;
  capacityManagementRoot: Successful<CapacityManagementRootRequest>;
};

export const EditTechnicalCapacity: FC<Props> = ({
  capacityManagementRoot,
  networkPoint,
}) => {
  const cmNetworkPoint = useCmNetworkPoint({
    capacityManagementRoot,
    networkPoint,
  });

  const technicalCapacity = useTechnicalCapacity({
    cmNetworkPoint,
  });

  useTitle('Edit Technical Capacity');

  return (
    <Page
      cmNetworkPoint={cmNetworkPoint}
      technicalCapacity={technicalCapacity}
    />
  );
};
